// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"Categories_cardsWrapper__W_5cj","root":"Categories_root__j30R_","rotated":"Categories_rotated__Z2MSM"};